type RegistrationMethod = 'email' | 'google'

/**
 * Sends only an aggregate conversion signal after the API has accepted a new
 * registration. Never include a member ID, email address, profile fields, or
 * free-form user input in an analytics event.
 */
export const trackRegistrationCompleted = (method: RegistrationMethod) => {
  if (typeof window === 'undefined' || !window.zaraz) return

  try {
    void window.zaraz.track('sugarm_registration_completed', {
      registration_method: method
    })
  } catch {
    // Analytics must never prevent a completed registration from continuing.
  }
}
